import React, { useState } from "react";

const UserDetails = ({ details }) => {
  return (
    <div className="user-detail-table">
      <table className="tabledetails table-borderless user-det w-100 mb-5">
        <thead>
          <th colspan="3" className="h8 mb-0 font-weight-light p-3">
            BASIC DETAILS
          </th>
        </thead>
        <tbody>
          <tr>
            <td style={{ width: "40%" }}>Name</td>
            <td>:</td>
            <td>{details?.name}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>E-mail ID</td>
            <td>:</td>
            <td>{details?.email}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Mobile Number</td>
            <td>:</td>
            <td>{details?.mobile}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>DOB</td>
            <td>:</td>
            <td>{details?.dob}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>Martial Status</td>
            <td>:</td>
            <td>{details?.marital_status}</td>
          </tr>
          <tr>
            <td style={{ width: "40%" }}>City</td>
            <td>:</td>
            <td>{details?.city}</td>
          </tr>
          {details?.detail?.id ? (
            <>
              {" "}
              <tr>
                <td style={{ width: "40%" }}>Legal Name</td>
                <td>:</td>
                <td>{details?.detail?.legal_name}</td>
              </tr>
              <tr>
                <td style={{ width: "40%" }}>GST Number</td>
                <td>:</td>
                <td>{details?.detail?.gst_number}</td>
              </tr>
              <tr>
                <td style={{ width: "40%" }}>GST Address</td>
                <td>:</td>
                <td>{details?.detail?.gst_address}</td>
              </tr>
              <tr>
                <td style={{ width: "40%" }}>Contact Number</td>
                <td>:</td>
                <td>{details?.detail?.gst_contact_number}</td>
              </tr>
              <tr>
                <td style={{ width: "40%" }}>GST E-mail</td>
                <td>:</td>
                <td>{details?.detail?.gst_email}</td>
              </tr>
            </>
          ) : null}

          <tr>
            <td style={{ width: "40%" }}>VOW Money</td>
            <td>:</td>
            <td>
              {details?.wallet_amount ? "₹" + details?.wallet_amount : ""}
            </td>
          </tr>

          <tr>
            <td style={{ width: "40%" }}>Refferal Count</td>
            <td>:</td>
            <td>{details?.refferals_count}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default UserDetails;
